import { Directive } from '@angular/core';


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-input-group-label'
})
export class InputGroupLabelDirective {}

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-input-group-addon-left'
})
export class InputGroupAddonLeftDirective {}

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-input-group-addon-right'
})
export class InputGroupAddonRightDirective {}

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-input-group-content'
})
export class InputGroupContentDirective {}
